var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fm-tag",class:_vm.tagCls},[_vm._t("default"),(_vm.isClosable)?_c('i',{staticClass:"fmico fmico-cha",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('close')}}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }